function parseThresholdPercent(root) {
  const raw = root.dataset.thresholdPercent;
  const n = parseFloat(raw, 10);
  if (!Number.isFinite(n)) {
    return 0;
  }
  return Math.min(1, Math.max(0, n / 100));
}

function setupRoot(root, lottie) {
  const url = root.dataset.lottieUrl;
  const container = root.querySelector('.lottie-animation__inner');
  if (!url || !container) {
    return;
  }

  const playMode = root.dataset.playMode || 'repeat_on_viewport';
  const loop = root.dataset.loop === '1';
  const threshold = parseThresholdPercent(root);

  const anim = lottie.loadAnimation({
    container,
    renderer: 'svg',
    loop,
    autoplay: false,
    path: url,
  });

  let startedOnce = false;

  const handleLeave = () => {
    if (playMode !== 'repeat_on_viewport') {
      return;
    }
    anim.stop();
    anim.goToAndStop(0, true);
  };

  let observer;

  const handleEnter = () => {
    if (playMode === 'once') {
      if (startedOnce) {
        return;
      }
      startedOnce = true;
      anim.play();
      if (observer) {
        observer.disconnect();
      }
      return;
    }
    anim.play();
  };

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const visibleEnough =
          entry.isIntersecting && entry.intersectionRatio >= threshold;

        if (visibleEnough) {
          handleEnter();
        } else {
          handleLeave();
        }
      });
    },
    { threshold: [threshold] }
  );

  observer.observe(root);
}

function scan() {
  const pending = Array.from(
    document.querySelectorAll('.lottie-animation[data-lottie-url]')
  ).filter((el) => el.dataset.lottieInitialized !== '1');

  if (!pending.length) {
    return;
  }

  pending.forEach((el) => {
    el.dataset.lottieInitialized = '1';
  });

  void import(/* webpackChunkName: "lottie-web" */ 'lottie-web').then(
    ({ default: lottie }) => {
      pending.forEach((root) => setupRoot(root, lottie));
    }
  );
}

function boot() {
  scan();

  if (!document.body || document.body.dataset.lottieScanBound === '1') {
    return;
  }
  document.body.dataset.lottieScanBound = '1';

  const mo = new MutationObserver(() => {
    scan();
  });
  mo.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
